<template>
  <div>
    <div class="time">{{ item.time }}</div>
    <div class="vs" v-for="game in item.games" :key="game.id" @click="goPages(game.id)">
      <div class="team">
        <img :src="filterImage(game.homeTeam.badge, 52, 52)">
        <img :src="requireImg(clothPrefix + game.homeClothesColor)"
          v-if="game.type == 'game' && game.homeClothesColor > 0" class="yf" />
        <div style="text-align: center; max-width: 90px;">
          {{ game.homeTeamAlias || game.homeTeam.name }}
        </div>
      </div>
      <div class="content">
        <div class="title" v-if="game.name">
          <div style="font-size: 10px;">{{ game.name }}</div>
        </div>
        <div class="title" v-else-if="game.roundDescription === '决赛'">
          <div style="font-size: 12px;">决赛</div>
        </div>
        <div class="score">{{ getRegularScore(game, 'home') }} <span
            style="font-size: 14px;"> —
          </span> {{ getRegularScore(game, 'away') }}</div>
        <div v-if="game.homePenalty !== -1 && game.awayPenalty !== -1" class="penalty">(点球: {{ game.homePenalty }}:{{ game.awayPenalty }})</div>
        <div :style="{ color: gameStatusMap(game).color }" class="state">{{ gameStatusMap(game).label }}</div>
      </div>
      <div class="team">
        <img :src="filterImage(game.awayTeam.badge, 52, 52)">
        <img :src="requireImg(clothPrefix + game.awayClothesColor)"
          v-if="game.type == 'game' && game.awayClothesColor > 0" class="yf" />
        <div style="text-align: center; max-width: 90px;">
          {{ game.awayTeam.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppType } from '@/constants/appType'
import { QNImageUtil } from '@/utils'
export default {
  props: {
    item: {
      typeof: Object,
      default: {}
    },
    clothPrefix: String
  },
  methods: {
    // 计算常规时间比分（总分 - 点球 - 加时）
    getRegularScore(game, team) {
      if (!game) return ''
      
      const scoreKey = team === 'home' ? 'homeScore' : 'awayScore'
      const penaltyKey = team === 'home' ? 'homePenalty' : 'awayPenalty'
      const plusKey = team === 'home' ? 'homePlus' : 'awayPlus'
      
      // 安全地获取数值并转换为数字类型
      const totalScore = typeof game[scoreKey] === 'number' ? game[scoreKey] : (game[scoreKey] ? Number(game[scoreKey]) : -1)
      const penaltyScore = game[penaltyKey] && game[penaltyKey] !== -1 ? Number(game[penaltyKey]) : 0
      const plusScore = game[plusKey] && game[plusKey] !== -1 ? Number(game[plusKey]) : 0
      
      // 如果总分小于0或不是有效数字，说明没有比分数据，返回空字符串
      if (totalScore < 0 || isNaN(totalScore)) {
        return ''
      }
      
      // 常规时间 = 总分 - 点球 - 加时
      const regularScore = totalScore - penaltyScore - plusScore
      
      // 确保结果非负，如果计算结果为负则返回总分
      return regularScore >= 0 ? regularScore : totalScore
    },
    gameStatusMap(game) {
      var liveStatus = game.liveStatus
      var ret = {}
      if (liveStatus) {
        ret = {
          label: liveStatus.statusLabel // 默认label，默认字体颜色黑色
        }
        if (liveStatus.status === -3 || liveStatus.status === 0 || (liveStatus.status === -1 && liveStatus.statusLabel === '即将直播')) {
          ret.color = '#CF2F30'
          if (liveStatus.status === -3) {
            ret.label = '即将直播'
          }
        } else if ((liveStatus.status === -1 && liveStatus.statusLabel === '比赛进行中') || liveStatus.status === 1) {
          ret.color = '#CF2F30'
          if (liveStatus.status === 1) {
            ret.label = this.$t('match.schedule.text_2')
          }
        } else if (liveStatus.status === 2) {
          ret.color = '#369AD4'
        } else if (liveStatus.status === -1 && (liveStatus.statusLabel === '比赛结束' || liveStatus.statusLabel === '比分录入中')) {
          if(liveStatus.statusLabel === '比赛结束') {
            ret.label = this.$t('match.schedule.text_3')
          }
          ret.color = '#ababab'
        }
      } else if (game.stateDesc) {
        if (game.state === 1) {
          ret.color = '#38906B'
          ret.label = '等待开赛'
        } else if (game.state === 0) {
          ret.color = '#38906B'
          ret.label = '正在报名'
        } else if (game.state === 2) {
          ret.label = game.stateDesc
          ret.color = '#CF2F30'
        } else if (game.state === 3) {
          ret.label = game.stateDesc
        }
      } else {
        if (game.gameNotBegin === 1) {
          ret.color = '#38906B'
          ret.label = this.$t('match.schedule.text_1')
        } else if (game.gameEnd === 0) {
          ret.color = '#CF2F30'
          ret.label = '比赛进行中'
        } else {
          ret.color = '#369AD4'
          ret.label = this.$t('match.schedule.text_3')
        }
      }
      if(liveStatus && liveStatus.statusLabel=='视频录像') {
        ret.label = this.$t('match.schedule.text_4')
      }
      return ret
    },
    goPages(id) {
      if (AppType.isInApp()) {
        window.location.href = `banmabang://gamedetail?gameId=${id}`
      } else {
        this.$router.push({ path: '/event/activity', query: { gameId: id } })
      }
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    requireImg(url) {
      return require(`@/assets/images/${url}.png`)
    }
  }
}
</script>

<style scoped lang="scss">
.time {
  background-color: #F2F2F2;
  font-size: 14px;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.vs {
  background-color: #fff;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F2F2F2;
  position: relative;

  .team {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #656565;
    position: relative;
    flex: 1;
    font-size: 12px;

    img {
      width: 52px;
      height: 52px;
      border-radius: 5px;
      margin-bottom: 10px;
    }

    .yf {
      position: absolute;
      width: 20px;
      height: 20px;
      right: 15px;
      top: 35px;
    }
  }

  .content {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

    .title {
      position: absolute;
      top: 0;
      border-top: 15px solid #dd0000;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      height: 0;
      width: 60px;
      color: #fff;

      div {
        width: 100%;
        position: absolute;
        text-align: center;
        top: -16px;
        left: 50%;
        transform: translateX(-50%);
        line-height: 1rem;
      }
    }

    .ranking-desc-bg-2 {
      border-top: solid 15px darkorange;
    }

    .ranking-desc-bg-3 {
      border-top: solid 15px #dd7700;
    }

    .ranking-desc-bg-4 {
      border-top: solid 15px green;
    }

    .ranking-desc-bg-5 {
      border-top: solid 15px #00aaaa;
    }

    .ranking-desc-bg-6 {
      border-top: solid 15px darkblue;
    }

    .ranking-desc-bg-7 {
      border-top: solid 15px purple;
    }

    .ranking-desc-bg-8 {
      border-top: solid 15px black;
    }

    span {
      margin-bottom: 10px;
      color: #9B9B9B;
      font-size: 12px;
    }

    .score {
      font-size: 18px;
      span {
        display: inline-block;
        font-weight: 600;
        color: #000;
        padding-bottom: 0px;
        margin-bottom: 0px;
      }
    }
    .penalty{
      font-size: 12px;
      color: #9B9B9B;
    }

    .state {
      font-size: 12px;
      margin-top: 8px;
    }
  }
}
</style>
